import { useTranslation } from 'react-i18next'
import { RankmiTable } from '@rankmi/rankmi-table'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'
import { ICourse } from 'interfaces/learningPath'
import { useRolesAndPermissions } from '../../../../context/RolesAndPermissionsContext'
import { RankmiTableWrapper } from './styled'
import Options from './options'

interface ICoursesProps {
  addCourse: () => void
  disabled?: boolean
}

const Courses = ({ addCourse, disabled = false }: ICoursesProps) => {
  const { t } = useTranslation()
  const { roleDetail: data } = useRolesAndPermissions()
  const prefix =
    'configuration.rolesAndPermissions.form.sections.accessToCourses.courses'

  const columns = [
    {
      title: `${t(`${prefix}.table.headers.name`)}`,
      key: 'name',
      render: (name: string) => name,
    },
    {
      width: 66,
      align: 'center',
      render: (course: ICourse) => (
        <Options course={course} disabled={disabled} />
      ),
    },
  ]

  return (
    <RankmiTableWrapper>
      <RankmiTable columnHeaders={columns} data={data.courses} />
      <Button onClick={addCourse} disabled={disabled}>
        <FontAwesomeIcon icon={faPlus} />
        {t(`${prefix}.add`)}
      </Button>
    </RankmiTableWrapper>
  )
}

export default Courses
